/**
 *
 *  Echt Folding
 *  - Used for fold and unfold sections
 *
 *  Needing follow attributes in html
 *  - data-folding='{"folding":"next"}'
 *
 */
;(function ($, window) { // eslint-disable-line no-extra-semi
    /**
     * Component constructor
     * @param $element
     * @param data
     * @param breakpoint
     * @constructor
     */
    var Folding = function ($element, data, breakpoint) {
        /**
         * Assign the clicked element
         */
        this._$element = $element;

        /**
         * Store the html data object
         */
        this._data = data;

        /**
         * Save the current window.breakpoint();
         */
        this._breakpoint = breakpoint;

        /**
         * Combine default config with the element data object
         */
        this._config = $.extend(true, {}, Folding.defaults, this._data);

        /**
         * Bind click event to element
         */
        this._$element.on('click', this._init.bind(this));
    };

    /**
     * Default configuration object
     * @type {{data_attr: string, class_is_active: string, class_is_unfolded: string, close_siblings: string, scroll_to: boolean, scroll_to_offset_class: boolean, preventParent: boolean, map: null}}
     */
    Folding.defaults = {
        data_attr: '[data-folding]',
        class_is_active: 'is--active',
        class_is_unfolded: 'is--unfolded',
        close_siblings: 'true',
        scroll_to: false,
        scroll_to_offset_class: false,
        preventParent: false,
        map: null
    };

    /**
     * Folding init function
     * @returns {boolean}
     * @private
     */
    Folding.prototype._init = function () {
        /**
         * Check if breakpoint exist, or check if data-folding-breakpoint is defined
         */
        if (
            this._breakpoint !== undefined &&
            this._$element.data('folding-breakpoint') !== undefined &&
            this._$element.data('folding-breakpoint').split(',').indexOf(this._breakpoint()) === -1
        ) {
            return true;
        }

        /**
         * Store all folding items for map with position values
         * @type {*}
         */
        var $foldingItems = $(this._config.data_attr);

        /**
         * Empty object for top values declaration
         * @type {{}}
         */
        var objTop = {};

        /**
         * Loop throught the folding items and save position to objet
         */
        for (var i = 0; i < $foldingItems.length; i++) {
            objTop[i] = parseInt($foldingItems.eq(i).offset().top);
        }

        /**
         * Store object as config item
         * @type {{}}
         */
        this._config.map = objTop;

        /**
         * Call the folding function
         */
        this._foldingElement();
    };

    Folding.prototype._foldingElement = function () {
        /**
         * Check if option close_siblings is true, close unfolded sections
         */
        if (this._config.close_siblings === 'true') {
            $('.' + this._$element.attr('class'))
                .removeClass(this._config.class_is_active);
        }

        /**
         * Modify clicked element with a active class
         */
        this._$element
            .toggleClass(this._config.class_is_active);

        /**
         * Check if scroll_to config is true
         */
        if (this._config.scroll_to) {
            /**
             * If true call scrollTo function
             */
            this._scrollTo();
        }
    };

    Folding.prototype._scrollTo = function () {
        /**
         * Store current scroll position
         */
        var scrollTop = $(document).scrollTop();

        /**
         * Pick the new scroll position from the config map
         * @type {Number}
         */
        var offsetTop = parseInt(this._config.map[$(this._config.data_attr).index(this._$element)]);

        /**
         * Store the window height
         * @type {Number}
         */
        var vh = window.outerHeight;

        /**
         * Declare empty variable
         */
        var offsetClassTop;

        /**
         * Check if scroll_to_offset_class is true
         */
        if (this._config.scroll_to_offset_class) {
            offsetClassTop = $(this._config.scroll_to_offset_class).height();
            offsetTop -= offsetClassTop;
        }

        /**
         * Do not scroll if the element exist/visible in the current viewport
         */
        if (
            offsetTop > scrollTop &&
            offsetTop < (scrollTop + vh)
        ) {
            return;
        }

        /**
         * Okay lets go, scroll the view to given position
         */
        $('html, body')
            .animate({
                scrollTop: offsetTop
            }, 450);
    };


    /**
     * DOM READY GO GO GO!!!
     */
    $(function () {
        /**
         * Travel through the DOM for data-folding attributes
         * For each of the founded data attr create a new folding component
         */
        $('[data-folding]').each(function () {
            /**
             * Declare this as variable
             * @type {*}
             */
            var $element = $(this);

            /**
             * Store element data
             */
            var data = $element.data('folding');

            /**
             * Create folding component
             */
            new Folding($element, data, window.breakpoint);
        });
    });

})(jQuery, window);
